import { ShieldLockOpenOutlineIcon } from './ShieldLockOpenOutlineIcon';

/**
 * author: Michael Irigoyen
 * id F9C92AC8-D26D-4AAD-8C34-22759EA2CA2D
 * name shield-lock-open-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-lock-open-outline.svg
 * tags
 * - Home Automation 
 * - Lock 
 */
export const ShieldUnlockedOutlineIcon = ShieldLockOpenOutlineIcon;
export default ShieldUnlockedOutlineIcon